import * as React from "react";

const YoutubeFooterIconSVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40">
        <path
            fill="#F8FAFC"
            fillRule="evenodd"
            d="M31.499 14.223a3 3 0 0 0-2.122-2.121C27.505 11.6 20 11.6 20 11.6s-7.505 0-9.377.502a3 3 0 0 0-2.122 2.121C8 16.095 8 20 8 20s0 3.905.501 5.777a3 3 0 0 0 2.122 2.122C12.495 28.4 20 28.4 20 28.4s7.505 0 9.377-.501a3 3 0 0 0 2.122-2.122C32 23.905 32 20 32 20s0-3.905-.501-5.777m-13.9 9.377v-7.2l6.236 3.6z"
        ></path>
    </svg>
);

export default YoutubeFooterIconSVG;
